import React, { useEffect, useState } from "react";
import Marque from "./Marque";
import "../styles/skills.css";
import Carousel from "./Carousel";

import html5 from "../images/html5.png";
import NextJs from "../images/nextjs.png";
import ReactLogo from "../images/react.png";
import Css from "../images/css.png";
import Flask from "../images/flask.png";
import Vue from "../images/vue.png";
import Rest from "../images/rest.png";
import Nuxtjs from "../images/nuxt.png";
import Nodejs from "../images/nodejs.png";
import FastApi from "../images/fastapi.png";

import Figma from "../images/figma.png";
import Javascript from "../images/jslogo.png";
import AWS from "../images/aws.png";
import Jest from "../images/jest.png";
import Deploy from "../images/deploy.png";
import TypeScript from "../images/typescript.png";
import Java from "../images/java.png";
import Python from "../images/python.png";
import C from "../images/c.png";
import AdobePhotoShop from "../images/adobephotoshop.png";

import MongoDb from "../images/mongodb.png";
import Postgresql from "../images/postgres.png";
import Firebase from "../images/firebase.png";
import CICD from "../images/cicd.png";
import Git from "../images/git.png";
import Docker from "../images/docker.png";
import Selenium from "../images/selenium.png";
import Github from "../images/github.png";
import GraphiteDev from "../images/graphitedev.png";
import Redux from "../images/redux.png";

import BigText from "./BigText";
import SkillStates from "./SkillStates";
import { motion } from "framer-motion";

import GlowShade from "./GlowShade";

export default function Skills() {
  const images0 = [
    {
      image: html5,
      text: "I'm really good at using HTML5 to create solid website structures.",
    },
    {
      image: NextJs,
      text: "Next.js lets me create amazing websites effortlessly.",
    },
    {
      image: ReactLogo,
      text: "When it comes to building websites, React is my go-to library.",
    },
    {
      image: Css,
      text: "I use CSS to style websites and make them look awesome.",
    },
    { image: Flask, text: "Flask is my choice for building web applications." },
    {
      image: Vue,
      text: "For website development, Vue.js is my top pick among frameworks.",
    },
    {
      image: Rest,
      text: "I'm skilled at integrating REST APIs into websites.",
    },
    {
      image: Nuxtjs,
      text: "With Nuxt.js, I can create some really cool websites.",
    },
    {
      image: Nodejs,
      text: "Node.js serves as a solid runtime for website development.",
    },
    {
      image: FastApi,
      text: "FastAPI is the framework I prefer for building APIs.",
    },
  ];

  const images1 = [
    {
      image: Figma,
      text: "Figma helps me design user interfaces and collaborate with teammates.",
    },
    {
      image: Javascript,
      text: "JavaScript is my primary language for client-side scripting in web development.",
    },
    {
      image: AWS,
      text: "AWS is my preferred cloud computing platform for hosting web applications.",
    },
    {
      image: Jest,
      text: "I use Jest for testing JavaScript code in my projects.",
    },
    {
      image: Deploy,
      text: "I'm proficient in deploying applications to various hosting platforms.",
    },
    {
      image: TypeScript,
      text: "TypeScript adds static typing to JavaScript, making my code more predictable.",
    },
    {
      image: Java,
      text: "Java is a versatile programming language that I use for building robust backend systems.",
    },
    {
      image: Python,
      text: "Python is my preferred language for backend development and scripting tasks.",
    },
    {
      image: C,
      text: "C is a powerful programming language that I use for system programming.",
    },
    {
      image: AdobePhotoShop,
      text: "Adobe Photoshop is my tool for editing and manipulating images for web design.",
    },
  ];

  const images2 = [
    {
      image: MongoDb,
      text: "MongoDB is my go-to database for web applications.",
    },
    {
      image: Postgresql,
      text: "PostgreSQL is my preferred relational database for web applications.",
    },
    {
      image: Firebase,
      text: "Firebase is a great platform for building mobile and web applications.",
    },
    {
      image: CICD,
      text: "I'm skilled at setting up CI/CD pipelines for automating the deployment process.",
    },
    {
      image: Git,
      text: "Git is my preferred version control system for managing codebases.",
    },
    {
      image: Docker,
      text: "Docker is my tool for containerizing  and deploying them in isolated environments.",
    },
    {
      image: Selenium,
      text: "Selenium is my tool for automating web browser testing.",
    },
    {
      image: Github,
      text: "GitHub is my preferred platform for hosting code repositories and collaboration.",
    },
    {
      image: GraphiteDev,
      text: "Graphite Dev is my tool for sync and track my git commits.",
    },
    {
      image: Redux,
      text: "Redux is my go-to library for managing application state in React applications.",
    },
  ];

  const [skillstate, setSkillState] = useState(0);
  const [images, setImages] = useState(images0);
  const [bigtext, setBigText] = useState("Full Stack Web Development");

  useEffect(() => {
    switch (skillstate) {
      case 0:
        setBigText("Full Stack Web Development");
        setImages(images0);
        break;
      case 1:
        setBigText("Cloud/Test, Polyglot&UI/UX");
        setImages(images1);
        break;
      case 2:
        setBigText("Databases & DevTools");
        setImages(images2);
        break;
      default:
        setBigText("Full Stack Web Development");
        setImages(images0);
    }
  }, [skillstate]);

  return (
    <div className="skills">
      <Marque id="skills" text="Skills" top="-400px" />

      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        exit={{ opacity: 0, x: -40 }}
        key={skillstate}
      >
        <BigText text={bigtext} align="left" top="-150px" top2="-260px" />
      </motion.div>

      <GlowShade
        color="#824581"
        top="5%"
        left="-4%"
        height="200px"
        width="200px"
      />

      <SkillStates skillstate={skillstate} setSkillState={setSkillState} />

      <Carousel images={images} skillstate={skillstate} />
    </div>
  );
}
